import React from 'react';
import styles from './Resps.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../axios/Axios.js';
import { getToken } from "../../../services/auth";
import Modal from "./components/Modal"
import { useSnackbar } from 'notistack'

const Resps_all = (props) => (
  <>
    {props.resps[0] && props.resps.map(resps => (
      <RespItem photo={resps.data.photo} title={resps.data.title} name={resps.data.name} email={resps.email} deleteAct={props.deleteAct}/>
    ))}
  </>
); 


function RespItem(props) {

  return (
    <div className={styles.resp_content1}>
      <div className={styles.imageDiv}>
          <img
            className={styles.icon}
            src={props.photo}
            alt="alt text"
          />
      </div>
      <div className={styles.res_content_data}>
        <div className={styles.resp_name}>{props.name}</div>
        <div className={styles.resp_job_title}>{props.title}</div>
      </div>
      <button onClick={() =>props.deleteAct(props.email)} className={styles.deleteButton}>x</button>
    </div>
  )
}


function Resps(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    email: "",
    uuid: props.uuid,
    weight: 1
  });

  const RESPS_URL = "/resp"
  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [resps, setResps] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);

  const config = {
    params: {
      "uuid": props.uuid
    },
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const cleanData = () => {
    setFormData({
      email: "",
      uuid: props.uuid,
      weight: 1
    })
  }

  const reloadResps = () => {
    axiosBackend.get(RESPS_URL, config )
      .then(res => {
        setResps(res.data);
        setLoading(false);
      })
      .catch(err => {
        setErrMsg(err.message);
        setLoading(false);
      });
  }

  const deleteAct = async(email) => {
      await axiosBackend.delete(RESPS_URL, {
        params: {
          "uuid": props.uuid,
          "email": email
        },
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getToken()}`
        },
      }).then( (response) => {
        reloadResps();
        enqueueSnackbar('Responsável removido com sucesso!', { 
          variant: 'success'
        });
      }).catch ((error) => {
        enqueueSnackbar('Falha ao remover usuário!', { 
          variant: 'error'
        });
      });
  }

  useEffect(() => {
    setLoading(true);
    axiosBackend.get(RESPS_URL, config )
      .then(res => {
        setResps(res.data);
        setLoading(false);
      })
      .catch(err => {
        setErrMsg(err.message);
        setLoading(false);
      });
  }, [props.uuid]);


  return (
    <div className={styles.component}>
      <Modal reloadResps={reloadResps} formData={formData} setFormData={setFormData} isOpen={isModalOpen} onClose={() =>{cleanData(); setModalOpen(false);}} uuid={props.uuid}/>
      <div className={styles.button_div}>
        <button disabled={(resps.length >= 5) || loading} onClick={() => setModalOpen(true)} className={styles.m_button}>+ Adicionar responsável</button>
      </div>
      <div className={styles.dados_box}>
        <div className={styles.resp_content}>
          <Resps_all resps={resps} deleteAct={deleteAct}/>
        </div>
      </div>
    </div>
  );
}

export default Resps;